export const nameInitials = (value) => {
    if (!value)  {
        return '';
    }
    let valueStr = value.toString();

    return `${valueStr.charAt(0).toUpperCase()}.`;
};